import React from "react";
import { Input, Button } from "reactstrap";

function AmazonProductListingTabs({ tabs, activeTab, setActiveTab, search, setSearch, previewMode }) {
  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      
      <div className="brand-tabs d-flex align-items-center">
        {tabs.map(function (tab) {
          const isActive = activeTab === tab.key;

          return (
            <div
              key={tab.key}
              className={`main-tabs ${isActive && !previewMode ? "active" : ""}`}
              onClick={() => {
                if (!previewMode) {
                  setActiveTab(tab.key);
                }
              }}
              style={{ 
                cursor: previewMode ? "default" : "pointer",
                backgroundColor: previewMode ? "#ffffff" : undefined,
                color: previewMode ? "#888888" : undefined
              }}
            >
              {tab.label}
              <span className="tab-count"> ({tab.count})</span>
            </div>
          );
        })}
      </div>

      <div className="d-flex align-items-center justify-content-end flex-grow-1">
        <Input
          type="text"
          placeholder="Search fields..."
          value={search}
          className="w-50 me-2" 
          onChange={function (e) { setSearch(e.target.value); }}
          disabled={previewMode} 
        />
      </div>
      
    </div>
  );
}

export default AmazonProductListingTabs;